/** Farm grid dimensions. Plot ids are `row * GRID_COLS + col`. */
export const GRID_COLS = 6;
export const GRID_ROWS = 6;
export const PLOT_COUNT = GRID_COLS * GRID_ROWS;

/** World-space size of a plot and the distance between plot centres. */
export const PLOT_SIZE = 2;
export const PLOT_SPACING = 2.4;

/** Plots that start unlocked: the two centre columns of rows 2–4. */
export const STARTING_PLOTS: readonly number[] = [14, 15, 20, 21, 26, 27];
export const STARTING_COINS = 20;
export const STARTING_SEEDS = { daisy: 4, tulip: 2 } as const;

/** Real seconds per in-game day. `dayTime` 0 is midnight, 0.5 is noon. */
export const DAY_LENGTH = 480;
export const START_DAY_TIME = 0.3;
/** Morning time the farmer wakes up after sleeping. */
export const WAKE_TIME = 0.25;
/** The farmer can go to bed from this time of day onwards (or before dawn). */
export const BEDTIME = 0.75;

/** Seconds a single watering keeps soil moist. */
export const MOISTURE_DURATION = 50;
/** Soil below this moisture is considered "thirsty" by the smart tool. */
export const THIRSTY_THRESHOLD = 0.35;

export const MAX_ORDERS = 3;
export const ORDER_INTERVAL = 70;

export const GOLDEN_SELL_MULTIPLIER = 5;
export const GOLDEN_XP_MULTIPLIER = 3;
export const SEED_DROP_CHANCE = 0.3;
export const HYBRID_BONUS_SEED_CHANCE = 0.2;

export const RAIN_CHANCE_PER_DAY = 0.35;
export const RAINBOW_DURATION = 45;

/** Offline progress is capped so returning players are not overwhelmed. */
export const MAX_OFFLINE_SECONDS = 4 * 60 * 60;

export const PLOT_BASE_COST = 25;
export const PLOT_COST_GROWTH = 1.2;

export const MAX_FARM_NAME_LENGTH = 24;
